module.exports = __webpack_public_path__ + "images/790c1e5.png";